// Scoring for the "How to Use Resi" section quizzes (pure, no imports).
export const SECTION_QUIZ_PASS = 80;
export const scoreSectionQuiz = (quiz = [], answers = {}) => {
  const correct = quiz.filter((item, i) => answers[i] === item.answer).length;
  const score = quiz.length ? Math.round((correct / quiz.length) * 100) : 0;
  return { correct, total: quiz.length, score, passed: score >= SECTION_QUIZ_PASS };
};
